import {
  LayoutDashboard,
  ShoppingCart,
  Package,
  ShoppingBag,
  BarChart3,
  Users,
  Gift,
  Shield,
  FileText,
  Building2,
  Menu,
  X,
  ChevronDown,
  Receipt,
  Store,
  ShieldAlert,
  Activity,
  Settings,
  History,
  AlertCircle,
  PanelLeftClose,
  PanelLeftOpen,
} from 'lucide-react'
import { ReactNode, useState } from 'react'
import { Link, useLocation } from 'react-router'
import { cn } from '../lib/utils'
import { useSessionStore } from '../store/auth/auth.store'
import { authService } from '../services/auth.service'
import { LogOut, Loader2 } from 'lucide-react'
import { NotificationButton } from './ui/NotificationButton'
import { toast } from 'sonner'
import { useEffect } from 'react'
import { layoutService } from '../services/layout.service'
import { useDeviceStore } from '../store/auth/auth.store'
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from './ui/collapsible'
import { useSettingsBranding } from '../hooks/useSettingsBranding'
import { posRegisterService } from '../services/pos.service'

//CONSTANTE PARA OCULTAR MODULOS EN DESARROLLO Y MOSTRAR SOLO LOS DE PRODUCCION
const SHOW_ONLY_PRODUCTION_MODULES =
  import.meta.env.VITE_SHOW_ONLY_PRODUCTION_MODULES === 'true'

interface LayoutProps {
  children: ReactNode
}



const navigation = [
  {
    name: 'Panel General',
    href: '/',
    icon: LayoutDashboard,
    production: false,
  },
  {
    name: 'Configuración',
    icon: Settings,
    production: true,
    children: [
      //{ name: 'Plataforma', href: '/configuracion/plataforma' }, NO LISTO PARA PRODUCCION
      { name: 'Métodos de Pago', href: '/metodos-pago', permission: 'configuration.payment-method.view' },
      { name: 'Cajas', href: '/cash-registers', permission: 'configuration.cash.view' },
      { name: 'Plataforma', href: '/configuracion/plataforma', permission: 'configuration.configuration.view' },
      { name: 'Temas', href: '/configuracion/temas', permission: 'configuration.configuration.view' },
      { name: 'Impuestos', href: '/impuestos', permission: 'configuration.tax.view' },
      { name: 'Unidad de Medida', href: '/unidades-medida', permission: 'configuration.unit.view' },
      { name: 'Bancos', href: '/bancos', permission: 'configuration.bank.view' },

    ],
  },
  {
    name: 'Punto de Venta',
    href: '/pos',
    icon: ShoppingCart,
    production: true,
  },
  {
    name: 'Historial de caja',
    href: '/historial-caja',
    icon: History,
    production: true,
    permission: 'configuration.cash.view',
  },
  {
    name: 'Registro de Ventas',
    href: '/ventas',
    icon: Receipt,
    production: true,
  },
  {
    name: 'Inventario',
    icon: Package,
    production: true,
    children: [
      { name: 'Catálogo', href: '/catalogo', permission: 'inventory.catalog.view' },
      { name: 'Trazabilidad', href: '/inventario/movimientos', permission: 'inventory.traceability.view' },
      { name: 'Categorías', href: '/categorias', permission: 'inventory.category.view' },
      { name: 'Departamentos', href: '/departamentos', permission: 'inventory.department.view' },
      { name: 'Tipos de Producto', href: '/tipos-producto', permission: 'inventory.product-type.view' },
      { name: 'Casos de uso', href: '/casos-de-uso', permission: 'inventory.use-case.view' },
      { name: 'Transferencias', href: '/inventario/transferencias', permission: 'inventory.catalog-transfer.view' },
    ],
  },
  {
    name: 'Compras y Proveedores',
    href: '/compras',
    icon: ShoppingBag,
    permission: ['purchases.purchase.view', 'purchases.supplier.view'],
    production: true,
  },
  {
    name: 'Reportes',
    href: '/reportes',
    icon: BarChart3,
    production: false
  },
  { name: 'Clientes', href: '/clientes', icon: Users, production: false },
  { name: 'Programa de Lealtad', href: '/lealtad', icon: Gift, production: false },
  {
    name: 'Logs del Sistema',
    icon: Activity,
    production: true,
    children: [
      { name: 'Logs de Accesos', href: '/logs-accesos', permission: 'logs.access-log.view' },
      { name: 'Logs de Acciones', href: '/logs-acciones', permission: 'logs.activity-log.view' },
    ],
  },
  /*
  {
    name: 'Notificaciones',
    href: '/notificaciones',
    icon: Bell,
    production: true,
  },
  */
  {
    name: 'Usuarios y Permisos',
    href: '/usuarios',
    icon: Shield,
    production: true,
    permission: 'users.user.view',
  },
  {
    name: 'Sucursales',
    href: '/sucursales',
    icon: Building2,
    production: true,
    permission: 'sucursals.sucursal.view',
  },
  {
    name: 'Módulo Regulatorio',
    href: '/regulatorio',
    icon: FileText,
    production: true,
    children: [
      { name: 'Doctores', href: '/doctores' },
    ],
  },
  {
    name: 'Dashboard Sucursales',
    href: '/dashboard-sucursales',
    icon: Store,
    production: false
  },
]

export function Layout({ children }: LayoutProps) {
  const location = useLocation()
  const [sidebarOpen, setSidebarOpen] = useState(false)
  const [isCollapsed, setIsCollapsed] = useState(() => {
    const saved = localStorage.getItem('sidebar_collapsed')
    return saved ? JSON.parse(saved) : false
  })

  useEffect(() => {
    localStorage.setItem('sidebar_collapsed', JSON.stringify(isCollapsed))
  }, [isCollapsed])

  const [branches, setBranches] = useState<{ id: number, name: string }[]>([])
  const [selectedBranch, setSelectedBranch] = useState<{ id: number, name: string } | null>(null)
  const [openMenus, setOpenMenus] = useState<string[]>([])

  const [branchDropdownOpen, setBranchDropdownOpen] = useState(false)
  const [isLoggingOut, setIsLoggingOut] = useState(false)
  const { token, user, logout, activeBranchId, setActiveBranchId, isRevoked, revokeMessage, clearRevoked, setRevoked, canAction } = useSessionStore()
  const { branding } = useSettingsBranding({ mode: 'private', enabled: Boolean(token) })

  const [isOnline, setIsOnline] = useState<boolean | undefined>(undefined)

  const hasPermission = (permission?: string | string[]) => {
    if (!permission) return true
    return Array.isArray(permission)
      ? permission.some((action) => canAction(action))
      : canAction(permission)
  }

  const filteredNavigation = (SHOW_ONLY_PRODUCTION_MODULES
    ? navigation.filter(item => item.production)
    : navigation)
    .map((item) => {
      if (!('children' in item) || !item.children) return item

      return {
        ...item,
        children: item.children.filter((child) => {
          const permission = 'permission' in child && typeof child.permission === 'string'
            ? child.permission
            : undefined

          return !permission || canAction(permission)
        }),
      }
    })
    .filter((item) => {
      if ('children' in item && item.children) return item.children.length > 0

      return !('permission' in item) || hasPermission(item.permission)
    })


  const [branchToChange, setBranchToChange] = useState<{
    id: number
    name: string
  } | null>(null)

  const [branchBlockedOpen, setBranchBlockedOpen] = useState(false)

  useEffect(() => {
    let isMounted = true
    /*
      Servicio del layout para obtener las sucursales asignadas al usuario
      se agregan para gestionar la sucursal activa en la sesion del usuario
      en caso de que la sucursal activa no sea valida se muestra un mensaje de error
      y se permite seleccionar otra sucursal
      
    */
    layoutService.getMySucursales().then(data => {
      if (!isMounted) return
      setBranches(data)

      if (data.length === 0) {
        setRevoked('No tienes sucursales activas asignadas en este momento.')
        return
      }

      const currentActiveId = useSessionStore.getState().activeBranchId
      const isCurrentValid = currentActiveId && data.some(b => b.id === currentActiveId)

      if (!isCurrentValid) {
        const trustedDevice = useDeviceStore.getState().trustedDevice
        const defaultBranch = data.find(b => b.id === trustedDevice?.sucursal_id) || data[0]
        setActiveBranchId(defaultBranch.id)
        setSelectedBranch(defaultBranch)

        // Si ya teníamos un sucursal activa pero fue desactivada
        if (currentActiveId !== null) {
          window.location.reload()
        }
      } else {
        const current = data.find(b => b.id === currentActiveId)
        if (current) setSelectedBranch(current)
      }
    }).catch(e => {
      console.error(e)
      toast.error('Error al cargar sucursales asignadas')
    })

    return () => { isMounted = false }
  }, [logout, setActiveBranchId])

  useEffect(() => {
    const activeParents = filteredNavigation
      .filter(item => item.children?.some(child => location.pathname === child.href))
      .map(item => item.name)

    setOpenMenus(prev => Array.from(new Set([...prev, ...activeParents])))
  }, [location.pathname])

  /*
    Alterna la expansion de los menus del sidebar
  */
  const toggleMenu = (name: string) => {
    setOpenMenus(prev =>
      prev.includes(name)
        ? prev.filter(n => n !== name)
        : [...prev, name]
    )
  }

  /*
    Maneja el estado de conexion del navegador
    y muestra una notificacion cuando el navegador se queda sin conexion
  */
  useEffect(() => {
    const checkInitialState = async () => {
      try {
        const res = await layoutService.getBrowserConnectionState()
        setIsOnline(res)

        if (!res) {
          toast.error('Sin conexión a internet')
        }
      } catch (e) {
        console.error(e)
      }
    }
    checkInitialState()

    const handleOnline = () => {
      setIsOnline(true)
      toast.success('Conectado a internet')
    }

    const handleOffline = () => {
      setIsOnline(false)
      toast.error('Sin conexión a internet')
    }

    window.addEventListener('online', handleOnline)
    window.addEventListener('offline', handleOffline)

    return () => {
      window.removeEventListener('online', handleOnline)
      window.removeEventListener('offline', handleOffline)
    }
  }, [])

  /*
    Maneja el cierre de sesion del usuario
    llama al servicio de authService.logout() para cerrar sesion
    y limpia la sesion del usuario
    muestra un mensaje de exito
    y redirige al usuario a la pagina de inicio
  */
  const handleLogout = async () => {
    setIsLoggingOut(true)
    try {
      await authService.logout()
    } catch (e) {
      console.error(e)
    } finally {
      logout()
      setIsLoggingOut(false)
      toast.success('Sesión cerrada correctamente')
    }
  }

  /*
    Maneja el cambio de sucursal
    llama a la funcion setActiveBranchId para establecer la nueva sucursal activa
    y recarga la pagina
  */
  const confirmBranchChange = () => {
    if (!branchToChange) return

    setActiveBranchId(branchToChange.id)
    window.location.reload()
  }

  if (isRevoked) {
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/50 backdrop-blur-sm">
        <div className="w-full max-w-md rounded-2xl bg-white p-8 shadow-2xl text-center">
          <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-full bg-red-100">
            <ShieldAlert className="h-8 w-8 text-red-600" />
          </div>
          <h2 className="text-2xl font-bold text-slate-900 mb-2">Acceso Suspendido</h2>
          <p className="text-slate-500 mb-8">{revokeMessage || 'Se ha revocado tu acceso a la sucursal actual.'}</p>

          <button
            onClick={() => {
              if (branches.length === 0) {
                logout()
                window.location.href = '/'
              } else {
                clearRevoked()
                window.location.reload()
              }
            }}
            className="w-full rounded-xl bg-slate-900 px-4 py-3 font-semibold text-white transition-colors hover:bg-slate-800"
          >
            {branches.length === 0 ? 'Cerrar sesión' : 'Actualizar sesión'}
          </button>
        </div>
      </div>
    )
  }

  return (
    <div className="flex h-screen w-full max-w-[100vw] bg-slate-50 overflow-hidden overscroll-none">
      {/* Sidebar */}
      <aside
        className={cn(
          'fixed inset-y-0 left-0 z-50 transform border-r border-slate-200 bg-white transition-all duration-300 ease-in-out lg:static lg:inset-0',
          sidebarOpen ? 'translate-x-0' : '-translate-x-full',
          isCollapsed ? 'lg:w-[84px]' : 'lg:w-64',
          'w-64 lg:translate-x-0'
        )}
      >
        <div className="flex h-full flex-col">
          {/* Header */}
          <div className="border-b border-slate-200 p-4">
            <div className={cn("flex items-center", isCollapsed ? "justify-center" : "justify-between")}>
              {!isCollapsed && <img src={branding.logoMainUrl} alt={branding.companyName} className="h-14 w-auto max-w-[190px] object-contain" />}

              <button
                onClick={() => setIsCollapsed(!isCollapsed)}
                className="hidden lg:block rounded-md p-1.5 hover:bg-slate-100 text-slate-500 transition-colors"
                title={isCollapsed ? "Expandir menú" : "Contraer menú"}
              >
                {isCollapsed ? <PanelLeftOpen className="h-5 w-5" /> : <PanelLeftClose className="h-5 w-5" />}
              </button>

              <button
                onClick={() => setSidebarOpen(false)}
                className="rounded-md p-1 hover:bg-slate-100 lg:hidden"
              >
                <X className="h-5 w-5" />
              </button>
            </div>
          </div>

          {/* Branch Selector */}
          <div className="relative mt-3 px-3 pb-3 border-b border-slate-200">
            <button
              onClick={() => branches.length > 1 && setBranchDropdownOpen(!branchDropdownOpen)}
              disabled={branches.length <= 1}
              title={isCollapsed ? (selectedBranch?.name || 'Cargando...') : undefined}
              className={cn(
                'flex w-full items-center rounded-lg border border-slate-200 bg-slate-50 py-2 transition-colors',
                isCollapsed ? 'justify-center px-0' : 'justify-between px-3',
                branches.length > 1 ? 'hover:bg-slate-100 cursor-pointer' : 'opacity-80 cursor-default'
              )}
            >
              <div className={cn("flex items-center", !isCollapsed && "gap-2")}>
                <Building2 className="h-4 w-4 text-slate-600 shrink-0" />
                {!isCollapsed && (
                  <span className="text-sm text-slate-700 truncate">
                    {selectedBranch?.name || 'Cargando...'}
                  </span>
                )}
              </div>
              {!isCollapsed && branches.length > 1 && <ChevronDown className="h-4 w-4 text-slate-400 shrink-0" />}
            </button>

            {branchDropdownOpen && (
              <div className="absolute top-full right-0 left-0 z-10 mt-1 rounded-lg border border-slate-200 bg-white shadow-lg">
                {branches.map((branch) => (
                  <button
                    key={branch.id}
                    onClick={() => {
                      if (branch.id !== activeBranchId) {
                        setBranchDropdownOpen(false)
                        // Verificar si hay una sesión de caja abierta antes de permitir el cambio
                        posRegisterService.getRegisterContext()
                          .then((ctx) => {
                            if (ctx?.session) {
                              setBranchBlockedOpen(true)
                            } else {
                              setBranchToChange(branch)
                            }
                          })
                          .catch(() => {
                            // Si falla la consulta (ej. no hay caja asignada), permitir el cambio
                            setBranchToChange(branch)
                          })
                      } else {
                        setBranchDropdownOpen(false)
                      }
                    }}
                    className={cn(
                      'w-full px-3 py-2 text-left text-sm first:rounded-t-lg last:rounded-b-lg hover:bg-slate-50',
                      selectedBranch?.id === branch.id &&
                      'bg-primary/10 text-primary',
                    )}
                  >
                    {branch.name}
                  </button>
                ))}
              </div>
            )}
          </div>

          {/* Navigation */}
          <nav className="flex-1 space-y-1 overflow-y-auto p-3">
            {filteredNavigation.map((item) => {
              if (item.children) {
                const isActive = item.children.some(child => location.pathname === child.href)
                const isOpen = openMenus.includes(item.name)

                return (
                  <Collapsible
                    key={item.name}
                    open={isCollapsed ? false : isOpen}
                    onOpenChange={() => {
                      if (isCollapsed) {
                        setIsCollapsed(false)
                        if (!isOpen) toggleMenu(item.name)
                      } else {
                        toggleMenu(item.name)
                      }
                    }}
                    className="space-y-1"
                  >
                    <CollapsibleTrigger
                      title={isCollapsed ? item.name : undefined}
                      className={cn(
                        'flex w-full items-center rounded-lg py-2 transition-colors',
                        isCollapsed ? 'justify-center px-0' : 'justify-between px-3',
                        isActive
                          ? 'bg-primary/10 text-primary'
                          : 'text-slate-700 hover:bg-slate-100',
                      )}
                    >
                      <div className={cn("flex items-center", !isCollapsed && "gap-3")}>
                        <item.icon className="h-5 w-5 shrink-0" />
                        {!isCollapsed && <span className="text-sm font-medium">{item.name}</span>}
                      </div>
                      {!isCollapsed && <ChevronDown className={cn("h-4 w-4 transition-transform shrink-0", isOpen && "rotate-180")} />}
                    </CollapsibleTrigger>
                    <CollapsibleContent className="pt-1">
                      <div className="relative ml-3 border-l-2 border-slate-200 pl-3 space-y-0.5">
                        {item.children.map((child, idx) => {
                          const isChildActive = location.pathname === child.href
                          return (
                            <Link
                              key={child.name}
                              to={child.href}
                              onClick={() => setSidebarOpen(false)}
                              style={{
                                animationDelay: `${idx * 40}ms`,
                                animationFillMode: 'both',
                              }}
                              className={cn(
                                'flex items-center gap-2 rounded-lg px-3 py-2 text-sm transition-all duration-150',
                                'animate-in fade-in slide-in-from-left-2',
                                isChildActive
                                  ? 'bg-primary/15 text-primary font-medium'
                                  : 'text-slate-600 hover:bg-slate-100 hover:text-slate-900',
                              )}
                            >
                              <span
                                className={cn(
                                  'h-1.5 w-1.5 rounded-full shrink-0 transition-colors',
                                  isChildActive ? 'bg-primary' : 'bg-slate-300',
                                )}
                              />
                              {child.name}
                            </Link>
                          )
                        })}
                      </div>
                    </CollapsibleContent>
                  </Collapsible>
                )
              }

              const isActive = location.pathname === item.href
              return (
                <Link
                  key={item.name}
                  to={item.href!}
                  title={isCollapsed ? item.name : undefined}
                  onClick={() => setSidebarOpen(false)}
                  className={cn(
                    'flex items-center rounded-lg py-2 transition-colors',
                    isCollapsed ? 'justify-center px-0' : 'justify-between px-3 gap-3',
                    isActive
                      ? 'bg-primary/10 text-primary'
                      : 'text-slate-700 hover:bg-slate-100',
                  )}
                >
                  <span className={cn("flex items-center", !isCollapsed && "gap-3 w-full min-w-0")}>
                    <item.icon className="h-5 w-5 shrink-0" />
                    {!isCollapsed && <span className="truncate text-sm font-medium">{item.name}</span>}
                  </span>
                </Link>
              )
            })}
          </nav>

          {/* Footer */}
          <div className="border-t border-slate-200 p-4">
            <div className={cn("flex flex-col", isCollapsed ? "gap-4 items-center" : "gap-3")}>
              <div className={cn("flex items-center", !isCollapsed && "gap-3")}>
                <div className="flex h-10 w-10 shrink-0 overflow-hidden items-center justify-center rounded-full bg-primary/10">
                  {user?.avatar_url ? (
                    <img src={user.avatar_url} alt={user.name} className="h-full w-full object-cover" />
                  ) : (
                    <span className="text-sm font-medium text-primary">
                      {user?.name?.substring(0, 2).toUpperCase() || 'U'}
                    </span>
                  )}
                </div>
                {!isCollapsed && (
                  <div className="flex-1 overflow-hidden">
                    <div className="truncate text-sm font-medium text-slate-900">
                      {user?.name || 'Usuario'}
                    </div>
                    <div className="truncate text-xs text-slate-500">
                      {user?.role?.name || 'Vendedor'}
                    </div>
                  </div>
                )}
              </div>

              <div className={cn("flex items-center", isCollapsed ? "flex-col gap-3 w-full" : "gap-2 mt-1")}>
                {/* Pill de Estado */}
                {!isCollapsed ? (
                  <div className="flex-1 flex items-center justify-center gap-2 px-3 py-1.5 bg-white border border-slate-200/60 shadow-sm rounded-full">
                    <span className="relative flex h-2 w-2 shrink-0">
                      {isOnline && (
                        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
                      )}
                      <span className={cn("relative inline-flex rounded-full h-2 w-2 shrink-0", isOnline ? "bg-green-500" : "bg-red-500")}></span>
                    </span>
                    <span className="text-[10px] text-slate-500 font-bold uppercase tracking-widest">{isOnline ? 'En línea' : 'Sin conexión'}</span>
                  </div>
                ) : (
                  <div className="flex items-center justify-center h-8 w-8 rounded-full bg-white border border-slate-200/60 shadow-sm" title={isOnline ? 'En línea' : 'Sin conexión'}>
                    <span className="relative flex h-2 w-2 shrink-0">
                      {isOnline && (
                        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
                      )}
                      <span className={cn("relative inline-flex rounded-full h-2 w-2 shrink-0", isOnline ? "bg-green-500" : "bg-red-500")}></span>
                    </span>
                  </div>
                )}

                {/* Botones de Acción */}
                <div className={cn("flex items-center justify-center shrink-0", isCollapsed ? "flex-col gap-3" : "gap-2")}>
                  <div className="hidden lg:block shrink-0">
                    <NotificationButton mode="drawer" className="h-9 w-9 bg-white border border-slate-200/60 shadow-sm hover:shadow hover:bg-slate-50 text-slate-600 transition-all" />
                  </div>
                  <button
                    onClick={handleLogout}
                    disabled={isLoggingOut}
                    className="flex items-center justify-center rounded-full h-9 w-9 bg-white border border-slate-200/60 shadow-sm hover:shadow hover:bg-slate-50 text-slate-600 transition-all disabled:opacity-50 shrink-0"
                    title="Cerrar sesión"
                  >
                    {isLoggingOut ? <Loader2 className="h-4 w-4 animate-spin text-slate-400" /> : <LogOut className="h-4 w-4 shrink-0" />}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </aside>

      {/* Main Content */}
      <main className="flex-1 min-w-0 w-full h-full overflow-y-auto overflow-x-hidden overscroll-none">
        {/* Mobile header */}
        <div className="sticky top-0 z-40 border-b border-slate-200 bg-white px-4 py-3 lg:hidden">
          <div className="flex items-center justify-between">
            <button
              onClick={() => setSidebarOpen(true)}
              className="rounded-md p-1 hover:bg-slate-100"
            >
              <Menu className="h-6 w-6" />
            </button>
            <img src={branding.logoMainUrl} alt={branding.companyName} className="h-7" />
            <NotificationButton mode="popover" className="h-8 w-8 text-slate-400 hover:bg-slate-100 border-none bg-transparent shadow-none" />
          </div>
        </div>

        {children}
      </main>

      {branchToChange && (
        <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/50 backdrop-blur-sm">
          <div className="w-full max-w-md rounded-2xl bg-white p-6 shadow-xl">
            <h3 className="text-lg font-semibold text-slate-900">
              Cambiar sucursal
            </h3>

            <p className="mt-2 text-sm text-slate-600">
              ¿Deseas cambiar a {' '}
              <span className="font-medium">
                {branchToChange.name}
              </span>
              ?
            </p>

            <p className="mt-2 text-xs text-slate-500">
              La aplicación se recargará para actualizar la información de la
              sucursal seleccionada.
            </p>

            <div className="mt-6 flex justify-end gap-3">
              <button
                onClick={() => setBranchToChange(null)}
                className="rounded-lg border border-slate-300 px-4 py-2 text-sm hover:bg-slate-50"
              >
                Cancelar
              </button>

              <button
                onClick={confirmBranchChange}
                className="rounded-lg bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:bg-primary/90"
              >
                Confirmar
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Modal: cambio bloqueado por sesión abierta */}
      {branchBlockedOpen && (
        <div className="fixed inset-0 z-[60] flex items-center justify-center bg-black/50 backdrop-blur-sm">
          <div className="w-full max-w-md rounded-2xl bg-white p-6 shadow-xl">
            <div className="flex items-start gap-4">
              <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-full bg-amber-100">
                <AlertCircle className="h-5 w-5 text-amber-600" />
              </div>
              <div>
                <h3 className="text-base font-semibold text-slate-900">
                  No se puede cambiar de sucursal
                </h3>
                <p className="mt-1.5 text-sm text-slate-600">
                  Hay una sesión de caja activa en la sucursal actual. Debes cerrar
                  la caja antes de cambiar de sucursal.
                </p>
              </div>
            </div>

            <div className="mt-6 flex justify-end">
              <button
                onClick={() => setBranchBlockedOpen(false)}
                className="rounded-lg bg-slate-900 px-4 py-2 text-sm font-medium text-white hover:bg-slate-800"
              >
                Entendido
              </button>
            </div>
          </div>
        </div>
      )}
      {/* Overlay */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 z-40 bg-black/50 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}
    </div>
  )
}
